import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { useStoreState } from 'easy-peasy';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import client from '../../../utils/apolloClient';

const deleteGroupMutation = gql`
  mutation deleteGroup($input: NavigateMenuModifierGroupInput) {
    delete_menu_modifier_group(input: $input) {
      modifier_group_id
      error {
        description
      }
    }
  }
`;

const GlobalMenuUpdate = ({ groupId }) => {
  const { userId } = useStoreState(state => state.auth);

  return (
    <Mutation
      client={client.clientPrivate}
      mutation={deleteGroupMutation}
      onCompleted={({ delete_menu_modifier_group }) => {
        if (!isNull(delete_menu_modifier_group.error)) {
          delete_menu_modifier_group.error.map(item =>
            toast.error(item.description),
          );
        } else {
          toast.success('Modifier Group deleted successfully!');
          window.location.reload(true);
        }
      }}
    >
      {(delete_menu_item, { loading }) => (
        <button
          className={`button ${loading && 'is-loading'}`}
          disabled
          onClick={() => {
            swal({
              title: 'Are you sure?',
              // eslint-disable-next-line max-len
              text: `Are you sure you want to delete this Modifier Group?`,
              buttons: ['Cancel', 'Yes'],
              dangerMode: true,
            }).then(willDelete => {
              if (willDelete) {
                delete_menu_item({
                  variables: {
                    input: {
                      user_id: userId,
                      modifier_group_id: groupId,
                    },
                  },
                });
              }
            });
          }}
        >
          <i className="fas fa-trash has-text-grey" />
        </button>
      )}
    </Mutation>
  );
};

export default GlobalMenuUpdate;
